<template>
  <div>
    <article class="loginCon">
      <main class="flexUpDownCenter flexAro loginMain">
        <section>
          <!--蓝色-->
          <div v-if="storeskinthemecolor == 1" class="loginImg">
            <img class="imgAlign" src="https://presale.jhtsoft.com/picms/c9ab902e5fa58.png">
            <img class="pa picImg" src="https://presale.jhtsoft.com/picms/12781b855f1019.png">
            <img class="pa leafImg" src="https://presale.jhtsoft.com/picms/12781ec2272b5b.png">
            <img class="pa outImg" src="https://presale.jhtsoft.com/picms/127812f92462d5.png">
          </div>
          <!--绿色-->
          <div v-else-if="storeskinthemecolor == 2" class="loginImg">
            <img class="imgAlign" src="https://presale.jhtsoft.com/picms/c9abd198d5e28.png">
            <img class="pa picImg" src="https://presale.jhtsoft.com/picms/35f1614b8167c.png">
            <img class="pa leafImg" src="https://presale.jhtsoft.com/picms/35f30edb72598.png">
            <img class="pa outImg" src="https://presale.jhtsoft.com/picms/35f353bf5481c.png">
          </div>
          <!--橙色-->
          <div v-else class="loginImg">
            <img class="imgAlign" src="https://presale.jhtsoft.com/picms/c9ac07759e474.png">
            <img class="pa picImg" src="https://presale.jhtsoft.com/picms/35efab26f1800.png">
            <img class="pa leafImg" src="https://presale.jhtsoft.com/picms/35f0b39d95ea8.png">
            <img class="pa outImg" src="https://presale.jhtsoft.com/picms/35f0e7ecb1800.png">
          </div>
        </section>
        <section class="rithtMain">
          <div class="phonoBox" v-if="!isRuralVitalization">
            <span ref="logoTit"></span>
          </div>
          <img v-else alt="乡村振兴门店管理中心" src="https://presale.jhtsoft.com/picms/d3c6ce50f9ec.png">
          <div class="loginForm" :class="{'loginFormSpecial':!ewmorpcicon}">
            <h3>{{ewmorpcicon?"用户登录":"扫码登录"}}</h3>
            <div class="smsCon cursorHand">
              <div class="codelogo">
                <div class="triangleL" @click="changeLoginMode" :title="ewmorpcicon?'扫码登录':'用户密码登录'">
                </div>
                <div class="triangleR"></div>
                <i :class="['ermOrPcIcon',ewmorpcicon?'iconewm':'iconpc']"></i>
              </div>
            </div>
            <el-form :model="loginForm" v-if="ewmorpcicon">
              <el-form-item>
                <el-input clearable v-model="loginForm.name" placeholder="用户名"></el-input>
              </el-form-item>
              <el-form-item>
                <el-input show-password v-model="loginForm.pwd" placeholder="密码" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <slideCheck :key="randomnum"></slideCheck>
              </el-form-item>
              <el-button type="primary" @click="toLogin"
                :loading="loginLoading">{{!loginLoading?'登录':'登录中，请稍候...'}}</el-button>
            </el-form>
            <div v-else>
              <div class="qrcodeImg" v-loading="wxLoading">
                <img :src="wxImg" class="imgAlign">
                <div class="qrcodeError" v-show="wxOut">
                  <p>二维码已失效</p>
                  <button type="button" @click="getUniqueNumber">刷新二维码</button>
                </div>
                <div class="qrcodeSuccess" v-if="wxSuccess">
                  <p class="el-icon-success">扫描成功</p>
                  <button type="button">登录中...</button>
                </div>
              </div>
              <p class="qrcodeDesc">
                <i class="iconsm"></i>
                <em>微信扫码登录</em>
              </p>
            </div>
          </div>
        </section>
      </main>
      <a tag="footer" href="http://www.2wma.cn/" target="_blank" class="greyColor loginFooter">技术支持：金禾通</a>
    </article>

    <!-- S 短信验证 -->
    <el-dialog class="comDlog downLoadlDlog" :visible.sync="checkCodeVisible" :before-close="getCloseCheckDlog"
      append-to-body :close-on-click-modal="false">
      <div slot="title" class="flexUI">手机验证 <em class="redColor limitTxt" v-if="isLimit">亲，已达登录次数上限哦！</em></div>
      <el-form :model="checkForm" label-width="120px" class="comForm" @submit.native.prevent>
        <el-form-item v-if="!checkForm.isTestAccount" class="allWith">
          <p class="fz14">企业已开通短信验证登录，需向手机号码<em class="colorDanger">{{checkForm.phontel}}</em>发送短信验证！</p>
        </el-form-item>
        <el-form-item v-if="checkForm.isTestAccount" class="allWith">
          <p class="iconbulb greyColor">请使用登记的手机号码进行身份验证哦！如尚未登记，请联系相关工作人员！</p>
        </el-form-item>
        <el-form-item v-if="checkForm.isTestAccount" label="手机号码">
          <el-input v-model="checkForm.phontel" placeholder="请输入手机号码" maxlength="11" clearable
            :disabled="isLimit"></el-input>
        </el-form-item>
        <el-form-item label="验证码" class="codeRow">
          <el-input v-model="checkForm.checkCode" placeholder="请输入6位数验证码" maxlength="6" clearable
            :disabled="isLimit"></el-input>
          <el-button :type="isLimit?'info':'primary'" v-if="vftShow" class="btnRight" :loading="loading"
            @click="verification" :disabled="isLimit">获取验证码</el-button>
          <el-button type="info" plain disabled v-else class="btnRight">{{count}}秒后重发</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="toLogin(1)">确定</el-button>
        <el-button @click="getCloseCheckDlog">取消</el-button>
      </span>
    </el-dialog>
    <!-- E 短信验证 -->
    <el-dialog class="comDlog recoverDlog" title="当前微信尚未绑定账号" :before-close="shureOrCancel"
      :visible.sync="vxBingdingFormShow" :close-on-click-modal="false" append-to-body>
      <el-form :model="loginForm" class="vxBingdingBox commonForm" label-width="140px" :rules="rules"
        ref="vxBingdingBox">
        <template>
          <el-form-item label="账号" prop="name">
            <el-input clearable v-model="loginForm.name" placeholder="请输入账号"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="pwd">
            <el-input show-password v-model="loginForm.pwd" placeholder="请输入密码" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="loginForm.bindingvx">绑定当前微信</el-checkbox>
          </el-form-item>
        </template>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="shureOrCancel(1)">{{loginForm.bindingvx?'立即绑定':'登录'}}</el-button>
        <el-button @click="shureOrCancel(0)">取消</el-button>
      </span>
    </el-dialog>


    <!--S 密码修改-->
    <el-dialog :visible.sync="editPwdShow" class="comDlog editPDlg" :before-close="closePwdBox" append-to-body
      :close-on-click-modal="false">
      <div slot="title" class="dialog-title">密码过于简单，请修改密码后重新登录</div>
      <el-form :model="editPwdForm" :rules="passwdRules" label-width="140px" class="commonForm" ref="editPwdForm">
        <el-form-item label="新密码" prop="newPassWord">
          <el-input v-model="editPwdForm.newPassWord" maxlength="16" placeholder="请填写新密码" show-password
            clearable></el-input>
        </el-form-item>
        <el-form-item label="重复新密码" prop="samepwd">
          <el-input v-model="editPwdForm.samepwd" maxlength="16" placeholder="请重复确认新密码" show-password
            clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closePwdBox(1)">确定</el-button>
        <el-button @click="closePwdBox(0)">取消</el-button>
      </div>
    </el-dialog>
    <!--E 密码修改-->

    <!-- S 引导关注公众号 -->
    <el-dialog class="comDlog leadEwmDlog" :visible.sync="leadEwmShow" :append-to-body="true"
      :before-close="closeLeadShow" :close-on-click-modal="false" :show-close="false">
      <span class="el-icon-error btnLeadClose" @click="closeLeadShow" title="关闭"></span>
      <section class="leadContBox">
        <h2>为强化软件系统使用安全，<b class="redColor fwBold">请扫码关注“券销宝”公众号</b>绑定微信后登录！</h2>
        <div class="qrcodeImg" v-loading="wxLoading">
          <img :src="wxImg?wxImg:'https://presale.jhtsoft.com/picms/c47499b67d489.png'" />
          <div class="qrcodeError" v-show="wxOut">
            <p>二维码已失效</p>
            <el-button type="button" @click="getUniqueNumber">刷新二维码</el-button>
          </div>
          <div class="qrcodeSuccess" v-if="wxSuccess">
            <p class="el-icon-success">扫描成功</p>
            <el-button type="button">登录中...</el-button>
          </div>
        </div>
        <article><b>“券销宝”</b>为您提供<i class="redColor">全新</i>的系统导航和系统使用手册、<br>账户安全、快递订单汇总、软件升级等管理功能。</article>
        <ul>
          <li class="iconloadright"><i>1</i>推送系统登录通知，系统安全有保障；</li>
          <li class="iconloadright"><i>4</i>在线系统使用手册，随时随地可学习；</li>
          <li class="iconloadright"><i>2</i>统一移动管理入口，杜绝零星收藏记忆；</li>
          <li class="iconloadright"><i>5</i>系统快递订单汇总，时刻感知系统动态；</li>
          <li class="iconloadright"><i>3</i>亮点实用功能推介，保持系统的领先性；</li>
          <li class="iconloadright"><i>6</i>系统需求实时提交，让需求直达服务商；</li>
        </ul>
      </section>
      <p class="bottomTip">
        <img src="https://presale.jhtsoft.com/picms/ca087a93ece24.gif" alt="动画小熊">
      </p>
    </el-dialog>
    <!-- E 引导关注公众号 -->

    <!--S 绑定微信登录发现账号已绑定其他账号提示框-->
    <el-dialog class="comDlog codeDlog" title="系统提示" :visible.sync="messageWarning" :modal-append-to-body="false"
      :before-close="closeMessage" append-to-body :close-on-click-modal="false">
      <section class="flexUI">
        <i class="el-message__icon el-icon-warning"></i>
        <div>
          <p>{{activeMsgtxt}}{{errorDiffType == '257'?'请切换账号或更换微信号后重新扫码！':'用户信息已更新，请重新登录！'}}</p>
          <small v-if="errorDiffType == '257'" class="greyColor">您也可通过微信登录成功后，点击右上角&nbsp;&nbsp;<strong
              class="redColor">微信解绑</strong>&nbsp;&nbsp;解除当前微信号绑定的账号，再登录当前账号操作！</small>
          <small v-else-if="errorDiffType == '258'" class="greyColor">
            <!--引导关注微信弹窗开启，出现并发绑定情况v-if="leadEwmShow"-->
            账号已通过其他途径绑定微信号，如若不想更换账号，重新通过用户账号登录即可！
            <!--微信登录未绑定账号时，打开了绑定账号弹窗-->
            <!-- <template v-if="vxBingdingFormShow">如欲更换当前账号的微信号，请通过用户账号登入，进入首页点击右上角&nbsp;&nbsp;<strong class="redColor">微信解绑</strong>&nbsp;&nbsp;解除当前账号绑定的微信号，再使用当前微信登录绑定当前账号即可！</template> -->
          </small>
        </div>
      </section>
      <span slot="footer" class="dialog-footer" v-if="errorDiffType == '257'">
        <el-button type="primary" plain @click="closeMessage(1)">去解绑</el-button>
        <el-button type="primary" @click="closeMessage(0)">重新扫码</el-button>
      </span>
      <span slot="footer" class="dialog-footer" v-else-if="errorDiffType == '258'">
        <el-button type="primary" @click="closeMessage(2)">去登录</el-button>
      </span>
      <span slot="footer" class="dialog-footer" v-else>
        <el-button type="primary" @click="closeMessage(0)">我已了解</el-button>
      </span>
    </el-dialog>
    <!--E 绑定微信登录发现账号已绑定其他账号提示框-->

  </div>
</template>
<script>
  import { bus } from '../../util/bus.js';
  import api from '../../apis/api.js';
  import { mapActions } from "vuex";
  export default {
    name: 'Login',
    data() {
      let that = this;
      return {
        loginForm: {
          name: "",//用户名
          pwd: "",//密码
          bindingvx: true, // 是否绑定微信
        },
        slideCheckd: false, // 滑块是否验证
        // ------------------------- S 短信验证变量 -------------------------
        loading: false,//加载中
        checkCodeVisible: false,//短信验证弹窗显隐
        count: '',//验证码发送倒计时
        timer: null,
        vftShow: true,
        checkForm: {
          checkCode: '', //验证码
          phontel: '',
          isTestAccount: false, // 是否为演示账号
        },
        isLimit: false,//是否达到登录上限
        // ------------------------- E 短信验证变量 -------------------------
        isRuralVitalization: false,//是否是乡村振兴
        // 2023-05-11 S DHL 微信扫码登录
        ewmorpcicon: true,//二维码登录还是pc登录
        vxBingdingFormShow: false,
        rules: {
          name: [
            { required: true, message: '请输入账户名称', trigger: 'blur' }
          ],
          pwd: [
            { required: true, message: '请输入密码', trigger: 'blur' }
          ],
        },
        // 2023-05-11 E DHL 微信扫码登录
        unicode: '', // 微信登录获取二维码的code
        wxImg: '', // 微信二维码的路径
        wxOut: false, // 微信超时
        wxSuccess: false, // 二维码扫码成功
        wxTime: null, // 接收微信的定时器
        openid: '', // 获取的openid
        wxLoading: false, // 微信二维码加载遮罩
        //------------S 密码过于简单，强制弹出修改密码弹窗------------
        editPwdShow: false,//未登录状态修改密码弹窗
        editPwdForm: {
          newPassWord: '',
          samepwd: '',
        },
        passwdRules: {
          newPassWord: [
            { required: true, message: '新密码不能为空！', trigger: 'blur' },
            { min: 6, max: 16, message: '长度必须在 6 到 16 之间', trigger: 'blur' },
            {
              validator(rule, value, callback) {
                if (value == that.loginForm.pwd) {
                  callback(new Error('密码过于简单，请重新填写！'));
                } else {
                  callback();
                }
              },
              trigger: ["blur"]
            },
          ],
          samepwd: [
            { required: true, message: '重复确认密码不能为空！', trigger: 'blur' },
            { min: 6, max: 16, message: '长度必须在 6 到 16 之间', trigger: 'blur' },
            {
              validator(rule, value, callback) {
                if (value != that.editPwdForm.newPassWord) {
                  callback(new Error('重复确认密码不一致，请重新填写！'));
                } else {
                  callback();
                }
              },
              trigger: ["blur"]
            },
          ]
        },
        randomnum: 0,//随机数渲染加1
        loginLoading: false,//登录加载中
        //------------E 密码过于简单，强制弹出修改密码弹窗------------

        leadEwmShow: false,//登录引导关注
        messageWarning: false,//此微信号已绑定其他账号
        activeMsgtxt: '',//动态提示语
        errorDiffType: '',//异常的类型：257：当前微信已绑定其他账号  258：当前账号已绑定其他微信
        autologinstore:'',//总部跳转门店登录信息
        storeskinthemecolor:0, //皮肤 0:橙色 1：蓝色 2：绿色
      }
    },
    //================================================ 组件 ================================================
    components: {
      SlideCheck: resolve => require(["@/components/common/SlideCheck.vue"], resolve)
    },
    watch: {
      'loginForm.name'(val) {
        this.loginForm.name = val.replace(/\s+/g, "").replace('\\', "");
      },
      'loginForm.pwd'(val) {
        this.loginForm.pwd = val.replace(/\s+/g, "").replace('\\', "");
      },
      'checkForm.phontel'(val) {
        this.checkForm.phontel = val.replace(/(^\s+)|(\s+$)/g, "");
      },
      'checkForm.checkCode'(val) {
        this.checkForm.checkCode = val.replace(/(^\s+)|(\s+$)/g, "");
      },
      //面板切换，滑块验证重置
      ewmorpcicon(val) {
        bus.$emit('checkSlideCheck', { slideCheckd: false });//滑块验证重置为未拖动
      },
    },
    methods: {
      ...mapActions(['setBdis',"updateSkinTheme"]),
      //--------------------------------------------------------------------登录未绑定微信号的强制引导关注券销宝 2024-3-13
      //关闭引导关注弹窗
      closeLeadShow() {
        this.wxOut = false;
        this.wxSuccess = false;
        if (this.wxTime) {
          clearInterval(this.wxTime);
          this.wxTime = null;
        }//关闭定时器
        this.leadEwmShow = false;
      },
      //关闭提示框
      closeMessage(val) {
        this.messageWarning = false;
        if (val == 1) {//去解绑
          this.closeLeadShow();
          this.changeLoginMode();//切换微信登录面板
        } else if (val == 2) {//重新账号登录
          if (this.leadEwmShow) { //引导关注微信弹窗开启，出现并发绑定情况
            this.closeLeadShow();
          } else if (this.vxBingdingFormShow) {//微信登录未绑定账号时，打开了绑定账号弹窗
            this.shureOrCancel(0);//关闭弹窗
            this.changeLoginMode();//切换至账号登录面板
          }
        } else {//重新扫码
          if (this.wxTime) {
            this.wxOut = false;
            this.wxSuccess = false;
            clearInterval(this.wxTime);
            this.wxTime = null;
          }//关闭定时器
          this.getUniqueNumber();// 唯一编号获取接口
        }
      },
      //------------------------------------------------------------------------------密码过于简单，强制修改密码 2024-2-21
      // 关闭/确定修改密码
      closePwdBox(type) {
        if (type == 1) {
          this.$refs.editPwdForm.validate(flag => {
            if (flag) {
              let params = {
                type: 0,//0：门店
                username: this.loginForm.name,
                passWord: this.loginForm.pwd,
                newPassWord: this.editPwdForm.newPassWord,
              }
              api.UPDPASSWORD(params).then(res => {
                if (res.data.status == "200") {
                  this.$message({
                    type: 'success',
                    message: res.data.message
                  })
                  this.editPwdShow = false;
                  if (res.data.data == 1) { //账号是否绑定了微信：未开通强制引导关注券销宝（不管绑没绑定） 和 开通强制关注券销宝已绑定微信 都返回 1
                    this.loginForm.name = '';
                    this.loginForm.pwd = '';
                    bus.$emit('checkSlideCheck', { slideCheckd: false });//滑块验证重置为未拖动
                    this.randomnum++;//滑块重新渲染  
                  } else { //未绑定则弹出强制引导关注的
                    this.loginForm.pwd = this.editPwdForm.newPassWord;//新密码
                    this.getUniqueNumber();// 唯一编号获取接口
                    this.leadEwmShow = true;//打开引导关注券销宝弹窗
                  }
                  setTimeout(() => {
                    this.editPwdForm = {
                      newPassWord: '',
                      samepwd: '',
                    }
                    this.$refs.editPwdForm.clearValidate();
                  }, 50);
                } else {
                  this.$message({
                    type: 'error',
                    message: res.data.message
                  })
                }
              }).catch(err => { })
            }
          })
        } else {
          this.editPwdShow = false;
          this.editPwdForm = {
            newPassWord: '',
            samepwd: '',
          }
          this.$refs.editPwdForm.clearValidate();
        }
      },
      //------------------------------------------------------------------------------密码过于简单，强制修改密码 2024-2-21
      // 微信二维码登录 -------------------------------------------------------------- 微信二维码登录S 2023/05/12
      // 唯一编号获取接口
      getUniqueNumber() {
        if (this.unicode) {
          // 获取登录二维码
          this.getQrCodeUrl();
        } else {
          api.GET_UNIQUENUMBER({ num: 1 }).then(res => {
            if (res.data.status == "200") {
              this.unicode = res.data.data[0];
              // 获取登录二维码
              this.getQrCodeUrl();
            }
          })
        }
      },
      // 获取登录二维码
      getQrCodeUrl() {
        this.wxLoading = true;
        api.GET_QRCODEURL({ unicode: this.unicode }).then(res => {
          if (res.data.status == "200") {
            this.wxImg = res.data.data;
            this.wxOut = false;
            this.wxSuccess = false;
            let num = 0;
            if (this.wxTime) {
              clearInterval(this.wxTime);
              this.wxTime = null;
            }
            this.wxTime = setInterval(() => {
              // 获取关注二维码扫描结果
              this.getScanResult();
              num++
              if (num == 60) {
                this.wxOut = true;
                clearInterval(this.wxTime);
                this.wxTime = null;
              }
            }, 2000);
          }
          this.wxLoading = false;
        }).catch(res => {
          this.wxLoading = false;
        })
      },
      // 获取关注二维码扫描结果
      getScanResult() {
        api.GET_SCANRESULT({ unicode: this.unicode }).then(res => {
          if (res.data.status == "200" && res.data.data) {
            this.openid = res.data.data;
            this.wxSuccess = true;
            this.wxOut = false;
            if (this.wxTime) {
              clearInterval(this.wxTime);
              this.wxTime = null;
            }
            if (!this.leadEwmShow) { //正常的微信登录面板
              this.toLogin(2);
              // console.log('微信登录面板的登录')
            } else { //打开了引导关注券销宝弹窗
              this.toLogin(3);//直接登录并绑定openid
              // console.log('券销宝弹窗绑定微信登录')
            }
          }
        })
      },
      /**
       * Description： 更改登录方式
       * Author: DHL
       * Time: 2023-05-11
       * @returns {any}
       */
      changeLoginMode() {
        this.ewmorpcicon = !this.ewmorpcicon;
        if (!this.ewmorpcicon) {
          // 唯一编号获取接口
          this.getUniqueNumber();
        } else {
          this.wxOut = false;
          this.wxSuccess = false;
          if (this.wxTime) {
            clearInterval(this.wxTime);
            this.wxTime = null;
          }
        }
      },
      /**
       * Description: 微信绑定账号弹窗关闭事件
       * Author: DHL
       * Time: 2023-05-11
       * @param {any} v
       * @returns {any}
       */
      shureOrCancel(v) {
        if (v == 1) {
          this.toLogin(3);
        } else {
          this.vxBingdingFormShow = false;
          this.wxSuccess = false;
          this.wxOut = true;
          this.$refs['vxBingdingBox'].resetFields()
        }
      },
      // 微信二维码登录 -------------------------------------------------------------- 微信二维码登录E 2023/05/12
      // 打开短信验证弹窗
      getShowCheckDlog() {
        this.checkCodeVisible = true;
      },
      // 关闭短信验证弹窗
      getCloseCheckDlog() {
        this.checkCodeVisible = false;
        if (this.timer) {
          this.vftShow = true;
          clearInterval(this.timer);
          this.timer = null;
        }
        this.checkForm.isTestAccount = false;
      },
      // 验证码
      verification() {
        if (this.vftShow) {
          if (this.checkForm.isTestAccount) {
            if (this.checkForm.phontel == '') {
              this.$message.error('手机号码不能为空！');
              return
            } else if (this.telCheck(this.checkForm.phontel, 1) != 1) {
              this.$message.error('请输入正确的手机号码！');
              return
            }
          }
          this.loading = true;
          let vParams = {
            code: this.checkForm.isTestAccount ? this.checkForm.phontel : this.loginForm.name,
            type: this.checkForm.isTestAccount ? 1 : 0,
            source: 1
          }
          api.SENDCHECKCODEMSG(vParams).then(res => {
            this.loading = false;
            if (res.data.status == "200") {
              const TIME_COUNT = 60;
              if (!this.timer) {
                this.count = TIME_COUNT;
                this.vftShow = false;
                this.timer = setInterval(() => {
                  if (this.count > 0 && this.count <= TIME_COUNT) {
                    this.count--;
                  } else {
                    this.vftShow = true;
                    clearInterval(this.timer);
                    this.timer = null;
                  }
                }, 1000)
              }
            } else if (res.data.status == "401") {
              this.isLimit = true;
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              })
            }
          })
        }
      },
      // 获取用户加入仓分享信息
      getJoinsharepro() {
        api.GET_JOINSHAREPRO({}).then(res => {
          if (res.data.status == "200") {
            if (res.data.data && res.data.data != 'null') {
              sessionStorage.setItem('qydmInfo', JSON.stringify(res.data.data));
              localStorage.setItem('opensupplyper', res.data.data.opensupplyper)
            }
          } else {
            this.$message({
              type: 'error',
              message: '请拖动滑块验证!'
            })
          }
        })
      },
      // 获取域名配置
      getDomainList() {
        api.GET_DOMAINLIST({}).then(res => {
          if (res.data.status == "200") {
            if (res.data.data && res.data.data.length > 0) {
              let dataList = res.data.data;
              let pcDomainHref = '';
              let modDomainHref = '';
              let pcPickHref = '';
              let modPickHref = '';
              dataList.forEach(item => {
                if (item.attsys == 0) {
                  if (item.domaintype == 0) {
                    if (!pcDomainHref) {
                      pcDomainHref = item.reqdomain;
                      sessionStorage.setItem('pcDomainHref', item.reqdomain);
                    }
                  } else {
                    if (!modDomainHref) {
                      modDomainHref = item.reqdomain;
                      sessionStorage.setItem('modDomainHref', item.reqdomain);
                    }
                  }
                }
                if (item.attsys == 1) {
                  if (item.domaintype == 0) {
                    if (!pcPickHref && item.status) {
                      pcPickHref = item.reqdomain;
                      sessionStorage.setItem('pcPickHref', item.reqdomain);
                    }
                  } else {
                    if (!modPickHref && item.status) {
                      modPickHref = item.reqdomain;
                      sessionStorage.setItem('modPickHref', item.reqdomain);
                    }
                  }
                }
              })
            }
            // console.log(res.data.data, '域名配置信息');
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            })
          }
        })
      },
      // 元素控制接口
      async getSysconelementsinfo() {
        await api.GET_SYSCONELEMENTSINFO().then((res) => {
          if (res.data.status == "200") {
            // console.log(res.data.data, 'res.data.data');
            sessionStorage.setItem('elementsInfo', JSON.stringify(res.data.data));
          }
        })
      },
      // 登录成功之后跳转
      async loginIn(info) {
        if (info.objtype == 6) {
          await api.GET_FLOWDETAIL({ flowcode: info.pflowcode }).then(res => {
            if (res.data.status == "200") {
              if (res.data.data && res.data.data != 'null') {
                let pinfo = JSON.parse(localStorage.getItem('userInfoMd')); // 用户信息
                pinfo.salediscount = res.data.data.salediscount;
                pinfo.pflowname = res.data.data.flowname;
                localStorage.setItem('userInfoMd', JSON.stringify(pinfo));
                if (this.$route.query.isLogout == '1') {
                  this.$router.push({
                    name: '首页'
                  })
                  // this.loginLoading = false;
                } else {
                  if (sessionStorage.getItem('toHref')) {
                    window.location = sessionStorage.getItem('toHref');
                    // this.loginLoading = false;
                  } else {
                    this.$router.push({
                      name: '首页'
                    })
                    // this.loginLoading = false;
                  }
                }
              }
            }
          })
        } else {
          if (this.$route.query.isLogout == '1') {
            console.log('去首页cccccccccccccc')
            this.$router.push({
              name: '首页'
            })
            // this.loginLoading = false;
          } else if(this.autologinstore && this.autologinstore.userName && this.autologinstore.storeopertype && this.autologinstore.flowcode){
            console.log('去首页2222222222222222222222222222')
            this.$router.push({
              name: '二级门店管理',
              query:{
                storeopertype:this.autologinstore.storeopertype,
                flowcode:this.autologinstore.flowcode,
                status:this.autologinstore.status,
              }
            })
            
          }  else {
            if (sessionStorage.getItem('toHref')) {
              window.location = sessionStorage.getItem('toHref');
              // this.loginLoading = false;
            } else {
              console.log('去首页ddddddddddddddddddddddd')
              this.$router.push({
                name: '首页'
              })
              // this.loginLoading = false;
            }
          }
        }
      },
      SlideCheckTrue(info) {
        this.slideCheckd = info.slideCheckd;
      },
      // 登录接口
      toLogin(type) {
        let loginParam = {};
        if(type != 4){
          if (!this.loginForm.name && type != 2) {
            this.$message({
              type: 'error',
              message: '用户名不能空!'
            })
            return false;
          };
          if (!this.loginForm.pwd && type != 2) {
            this.$message({
              type: 'error',
              message: '密码不能空!'
            })
            return false;
          };
          if (!this.slideCheckd && type != 2 && type != 3) {
            this.$message({
              type: 'warning',
              message: '请拖动滑块验证!'
            })
            return false;
          }
          if (type == 1 && this.checkForm.isTestAccount && this.checkForm.phontel === '') {
            this.$message({
              type: 'error',
              message: '手机号码不能为空！'
            })
            return false;
          }
          if (type == 1 && this.checkForm.checkCode === '') {
            this.$message({
              type: 'error',
              message: '验证码不能为空!'
            })
            return false;
          }
          loginParam = {
            logintype: 0,
            storetype: 0,
            username: this.loginForm.name,
            pwd: this.loginForm.pwd,
            isloginbycode: 0
          }
          if (type == 1) {
            if (this.checkForm.isTestAccount) {
              loginParam.cmobile = this.checkForm.phontel;
            }
            loginParam.code = this.checkForm.checkCode;
            loginParam.isloginbycode = 1;
          }
          if (type == 2) {
            loginParam = {
              storetype: 0,
              logintype: 1,
              openid: this.openid
            }
          }
          if (type == 3 && (this.loginForm.bindingvx || this.leadEwmShow)) {
            loginParam.bindwx = 1;
            loginParam.openid = this.openid;
            if (this.leadEwmShow) {
              loginParam.accountlogintype = 1;//账号登录类型，0，普通账号登录；1：引导关注之后绑定微信账号登录
            }
          }
        }else{ //一级门店操作二级门店自动登录
          loginParam = {
            logintype: 0,
            storetype: 0,
            username: this.loginForm.name,
            centerlogin: 1
          }
        }
        let curstoreuser = null,
        oldname = null;
        if(localStorage.getItem("curstoreuser")) {
          curstoreuser = localStorage.getItem("curstoreuser");
          oldname = curstoreuser.split('#&@')[0];
        }
        if(!localStorage.getItem('storeskinthemecolor') || (localStorage.getItem('storeskinthemecolor')&&(localStorage.getItem('storeskinthemecolor') == 'undefined' || localStorage.getItem('storeskinthemecolor') == 'null')) || (localStorage.getItem('storeskinthemecolor')&&localStorage.getItem('storeskinthemecolor') != 'undefined' && localStorage.getItem('storeskinthemecolor') != 'null'&&(!curstoreuser || (curstoreuser && loginParam.logintype == 0 && oldname != this.loginForm.name) || (curstoreuser && loginParam.logintype == 1)))){
          loginParam.queryskin = 1;
        }
        if(localStorage.getItem('storeskinthemecolor')){
          console.log(localStorage.getItem('storeskinthemecolor'),typeof(localStorage.getItem('storeskinthemecolor')),'localStorage')
          console.log(localStorage.getItem('storeskinthemecolor')&&localStorage.getItem('storeskinthemecolor') != 'undefined' && localStorage.getItem('storeskinthemecolor') != 'null',(curstoreuser && loginParam.logintype == 0 && oldname != this.loginForm.name) || (curstoreuser && loginParam.logintype == 1),'uuuuuuuuuuuuu')
          if(curstoreuser){
            console.log((curstoreuser && loginParam.logintype == 0 && oldname != this.loginForm.name) || (curstoreuser && loginParam.logintype == 1),'aaaaaaaaaaa')
            console.log(oldname == this.loginForm.name,'nnnnnnnnnnn',oldname)
            console.log( loginParam.logintype ,'gggggggggggggggggggg',this.openid)
          }else{
            console.log(curstoreuser,'bbbbbbbbb')
          }
        }else{
          console.log(curstoreuser,typeof(curstoreuser),'curstoreuser')
          if(curstoreuser){
            console.log(!(oldname == this.loginForm.name || loginParam.logintype == 1),'111111111111')
          } 
        }
        this.loginLoading = true;
        api.LOGIN(loginParam).then(res => {
          if (res.data.status == '200') {
            let firstStep = false;
            if (localStorage.getItem("firstStep")) {
              firstStep = true;
            }
            //固定皮肤缓存 zly 2025-01-14 S
            let storeskinthemecolor = 0;
            if(localStorage.getItem('storeskinthemecolor') && localStorage.getItem('storeskinthemecolor') != 'undefined' && localStorage.getItem('storeskinthemecolor') != 'null'){
              storeskinthemecolor = Number(localStorage.getItem('storeskinthemecolor'))
            }
            let curstoreuser = null;
            if(localStorage.getItem("curstoreuser") && localStorage.getItem('curstoreuser') != 'undefined' && localStorage.getItem('curstoreuser') != 'null') {
              curstoreuser = localStorage.getItem("curstoreuser");
            }//当前用户
            //固定皮肤缓存 zly 2025-01-14 E
            localStorage.clear();
            sessionStorage.clear();
            if (firstStep) {
              localStorage.setItem("firstStep", 'yes')
            }
            localStorage.setItem('storeskinthemecolor',storeskinthemecolor);
            localStorage.setItem('curstoreuser',curstoreuser);
            let userinfo = res.data.data.userinfo;
            if (res.data.data.userinfo.objtype == 6 && userinfo.storeinfo) {
              userinfo.issupportdis = userinfo.storeinfo.issupportdis;
            }
            if(type==4){
              sessionStorage.setItem('autologinstore',JSON.stringify(this.autologinstore))
            }
            localStorage.setItem("curstoreuser",userinfo.username+'#&@'+userinfo.openid);//当前用户
            if(loginParam.queryskin == 1){
              if(userinfo && userinfo.skin != undefined && userinfo.skin != null){
                this.storeskinthemecolor = userinfo.skin;
                localStorage.setItem("storeskinthemecolor",userinfo.skin);//皮肤缓存
                this.updateSkinTheme(userinfo.skin);//更改皮肤
                this.changeLogoTheme(userinfo.skin);
              }else{
                this.storeskinthemecolor = 0;
                localStorage.setItem("storeskinthemecolor",0);
                this.updateSkinTheme(0);//更改皮肤
                this.changeLogoTheme(0);
              }
            }
            let cmpyinfo = res.data.data.cmpyinfo
            userinfo.isyccmpy = cmpyinfo.isyccmpy;
            userinfo.mainqydm = cmpyinfo.mainqydm;//所属主体的企业代码
            localStorage.setItem('xyjFhxm', 1); // 企业信息
            localStorage.setItem('userInfoMd', JSON.stringify(userinfo)); // 用户信息
            localStorage.setItem('cmpyinfo', JSON.stringify(res.data.data.cmpyinfo)); // 企业信息
            localStorage.setItem('isyccmpy',cmpyinfo.isyccmpy?cmpyinfo.isyccmpy:0)
            localStorage.setItem('presellconfig', JSON.stringify(res.data.data.presellconfig)); // 预售配置
            localStorage.setItem('sysmarinfo', JSON.stringify(res.data.data.sysmarinfo)); // 营销服务配置
            localStorage.setItem('pubconfiginfo', JSON.stringify(res.data.data.pubconfiginfo)); // 公共服务基础配置
            localStorage.setItem('pubordprintinfo', JSON.stringify(res.data.data.pubordprintinfo)); // 订单发货配置
            localStorage.setItem('menusmd', JSON.stringify(res.data.data.menusmd)); // 菜单权限
            if(this.getCookie('store_sessionId')){
              let store_sessionId = this.getCookie('store_sessionId') 
              localStorage.setItem('store_sessionId',store_sessionId)
            }  
            api.GET_QYDMLIST().then((res) => {
              if (res.data.status == "200") {
                let qydmlist = res.data.data;
                localStorage.setItem('qydmlist', JSON.stringify(qydmlist))
              }
            })
            // 服务配置
            sessionStorage.setItem('elementsInfo', '');
            // 获取域名配置
            this.getDomainList();
            // 元素控制接口
            this.getSysconelementsinfo()
            // 获取企业是否开通物流查询 2023/11/08
            this.getExpqManageInfo()
            if (res.data.data.presellconfig) {
              this.setBdis(res.data.data.presellconfig.bdis);
            }
            this.loginIn(res.data.data.userinfo);
          } else if (res.data.status == '401') {
            if (res.data.data.isTestAccount) {
              this.checkForm = {
                checkCode: '', //验证码
                phontel: '',
                isTestAccount: true, // 是否为演示账号
              }
            } else {
              this.checkForm = {
                checkCode: '', //验证码
                phontel: res.data.data.cmobile,
                isTestAccount: false, // 是否为演示账号
              }
            }
            if (this.timer) {
              this.vftShow = true;
              clearInterval(this.timer);
              this.timer = null;
            }
            this.isLimit = false;
            this.loginLoading = false;
            this.checkCodeVisible = true;
          } else {
            if (res.data.status == '211') {//微信未绑定账号 
              this.loginLoading = false;
              this.vxBingdingFormShow = true;
              this.loginForm.bindingvx = true;
            } else if (res.data.status == '255') {//密码过于简单,强制修改密码
              this.loginLoading = false;
              if (this.checkCodeVisible) {
                this.getCloseCheckDlog();//短信验证码弹窗关闭
              }
              this.editPwdShow = true;
            } else if (res.data.status == '256') {//账号未绑定微信,强制引导关注券销宝
              this.loginLoading = false;
              if (this.checkCodeVisible) {
                this.getCloseCheckDlog();//短信验证码弹窗关闭
              }
              this.getUniqueNumber();// 唯一编号获取接口
              this.leadEwmShow = true;//打开引导关注券销宝弹窗
            } else if (res.data.status == '257' || res.data.status == '258') {//257：当前微信已经绑定其他账号  258：当前账号已经绑定其他微信
              this.loginLoading = false;
              this.errorDiffType = res.data.status;
              if (!this.ewmorpcicon) {//二维码登录面板
                this.$alert(res.data.message, '系统提示', {
                  confirmButtonText: '确定',
                });
                return
              }
              if (this.leadEwmShow) {//打开了引导关注券销宝弹窗
                let msgstring = res.data.message;//包含两种情况：257:当前微信已经绑定其他账号；258:当前账号已经绑定其他微信
                this.activeMsgtxt = msgstring.replace("！", "，");
                this.messageWarning = true;
                return
              }
            } else {
              this.loginLoading = false;
              this.$alert(res.data.message, '系统提示', {
                confirmButtonText: '确定',
                type: 'warning'
              }).then(() => { //确定
                if (!this.ewmorpcicon && !this.vxBingdingFormShow) {//二维码面板打开且绑定账号弹窗未开启时，要关闭扫描结果
                  this.wxSuccess = false;
                  this.wxOut = true;
                }
              }).catch(() => { //取消
                if (!this.ewmorpcicon && !this.vxBingdingFormShow) {//二维码面板打开且绑定账号弹窗未开启时，关闭扫描结果
                  this.wxSuccess = false;
                  this.wxOut = true;
                }
              });
            }
          }
        }).catch(err => {
          this.loginLoading = false;
        })
      },
      //logo换肤
      changeLogoTheme(val){
        let logoTit = this.$refs.logoTit;
        if(logoTit){
          if(this.storeskinthemecolor == 1){
            logoTit.style.backgroundImage = "url('https://presale.jhtsoft.com/picms/ff8e4e38eefc3.png')";
          }else if(this.storeskinthemecolor == 2){ //绿色
            logoTit.style.backgroundImage = "url('https://presale.jhtsoft.com/picms/ff8ec619a6c0c.png')";
          }else{ //橙色
            logoTit.style.backgroundImage = "url('https://presale.jhtsoft.com/picms/ff8df742061a4.png')";
          }
        }
      },
      // 获取企业是否开通物流查询 2023/11/08
      getExpqManageInfo() {
        api.GET_EXPQMANAGEINFO().then(res => {
          if (res.data.status == "200" && res.data.data) {
            localStorage.setItem('oepnquery', JSON.stringify(res.data.data.oepnquery));
          } else {
            localStorage.setItem('oepnquery', JSON.stringify(0));
          }
        })
      }
    },
    mounted(){
      //地址带传参过来自动登录
      if(sessionStorage.getItem('autologinstore')){
        this.autologinstore = JSON.parse(sessionStorage.getItem('autologinstore'));
        this.storeopertype = this.autologinstore.storeopertype;
        this.loginForm.name = decodeURIComponent(this.autologinstore.userName);
        this.toLogin(4);//自动登录
      }
      if(localStorage.getItem('storeskinthemecolor') && localStorage.getItem('storeskinthemecolor') != 'undefined' && localStorage.getItem('storeskinthemecolor') != 'null'){
        this.storeskinthemecolor = Number(localStorage.getItem('storeskinthemecolor'));
      }
      setTimeout(() => {
        this.changeLogoTheme(this.storeskinthemecolor)
      }, 5); 
    },
    created() {
      if (this.returnDomain()) {
        this.isRuralVitalization = true;
      };
      bus.$on('checkSlideCheck', this.SlideCheckTrue)

    },
    beforeDestroy() {
      // 销毁监听事件
      bus.$off('checkSlideCheck');
      if (this.timer) {
        this.vftShow = true;
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  }
</script>
<style scoped>
  .loginCon {
    width: 100vw;
    height: 100vh;
    background: #fff;
    overflow: hidden;
  }

  .loginMain {
    height: 90%;
    width: 100%;
    -o-justify-content: center;
    -ms-justify-content: center;
    -moz-justify-content: center;
    -webkit-justify-content: center;
    justify-content: center;
  }

  .loginImg {
    width: 610px;
    height: 510px;
    position: relative;
    perspective: 500;
  }

  .picImg {
    left: 50px;
    top: -6px;
    -webkit-animation: seesaw 3s infinite;
    animation: seesaw 3s infinite;
  }

  .leafImg {
    right: 0;
    bottom: 55px;
    -webkit-animation: swing 3s ease-in-out forwards infinite;
    animation: swing 3s ease-in-out forwards infinite;
    -webkit-transform-origin: center bottom;
    transform-origin: center bottom;
  }

  @-webkit-keyframes swing {
    0% {
      -webkit-transform: rotate(2.5deg)
    }

    50% {
      -webkit-transform: rotate(-2.5deg) skewX(1.25deg) skewY(-1.25deg);
    }

    100% {
      -webkit-transform: rotate(2.5deg)
    }
  }

  @keyframes swing {
    0% {
      transform: rotate(2.5deg)
    }

    50% {
      transform: rotate(-2.5deg) skewX(1.25deg) skewY(-1.25deg);
    }

    100% {
      transform: rotate(2.5deg)
    }
  }

  .outImg {
    bottom: 35px;
    right: 70px;
  }

  .loginForm {
    -o-box-shadow: 0px 4px 14px 0px rgba(28, 36, 49, 0.12);
    -ms-box-shadow: 0px 4px 14px 0px rgba(28, 36, 49, 0.12);
    -moz-box-shadow: 0px 4px 14px 0px rgba(28, 36, 49, 0.12);
    -webkit-box-shadow: 0px 4px 14px 0px rgba(28, 36, 49, 0.12);
    box-shadow: 0px 4px 14px 0px rgba(28, 36, 49, 0.12);
  }

  .rithtMain {
    margin-top: -30px;
    margin-left: 9.5%;
  }

  .rithtMain img {
    height: 37px;
    margin-bottom: 45px;
  }
  .phonoBox {
    width: 100%;
    height: 62px;
    position: relative;
  }

  .phonoBox span {
    position: absolute;
    width: 100%;
    height: 62px;
    background: url('https://presale.jhtsoft.com/picms/b4cda15fe1644.png') no-repeat 0 0;
    background-size: auto 830px;
  }

  .loginForm {
    width: 400px;
    padding: 30px 30px 95px;
    -o-box-sizing: border-box;
    -ms-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  .loginForm .el-input,
  .loginForm .el-button {
    width: 340px;
  }

  .loginForm .el-button {
    margin-top: 20px;
  }

  .loginForm h3 {
    color: #333;
    font-size: 22px !important;
    font-weight: bold;
    margin-bottom: 60px;
  }

  .loginFooter {
    position: fixed;
    width: 100%;
    bottom: 30px;
    text-align: center;
  }

  @-webkit-keyframes seesaw {
    0% {
      -webkit-transform: translate3d(0, 0, 0);
    }

    50% {
      -webkit-transform: translate3d(0, 20px, 0);
    }

    100% {
      -webkit-transform: translate3d(0, 0, 0);
    }
  }

  @keyframes seesaw {
    0% {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }

    50% {
      -webkit-transform: translate3d(0, 20px, 0);
      transform: translate3d(0, 20px, 0);
    }

    100% {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
  }

  /*获取验证码弹窗 start */
  .downLoadlDlog>>>.el-dialog {
    width: 630px;
  }

  .downLoadlDlog>>>.el-form-item:not(.allWith) .el-form-item__content {
    min-width: 120px;
    width: 340px;
  }

  .downLoadlDlog>>>.el-form-item__content .el-input {
    width: 100%;
  }

  .downLoadlDlog>>>.comForm {
    margin-bottom: 50px !important;
  }

  .allWith>>>.el-form-item__content {
    margin-left: 65px !important;
  }

  .allWith .fz14 em.colorDanger,
  .allWith .fz14 .blueColor {
    padding: 0 5px;
  }

  .breathTit {
    color: #b3b3b3;
    line-height: 20px;
    padding-top: 50px;
  }

  .codeRow>>>.el-form-item__content {
    display: flex;
    justify-content: space-between;
  }

  .codeRow>>>.el-form-item__content .el-input {
    width: calc(100% - 125px);
  }

  .codeRow .btnRight {
    margin-left: 10px;
    box-sizing: border-box !important;
    width: 115px !important;
    padding: 0 !important;
  }

  .limitTxt {
    font-size: 12px;
    margin-left: 15px;
  }

  /*获取验证码弹窗 end */
  /* S 2023-05-11 DHL 微信扫码登录样式 */
  .loginForm {
    position: relative;
  }

  .smsCon {
    text-align: center;
    position: absolute;
    right: 0;
    top: 0;
    height: 64px;
    margin: 0 auto;
  }

  .smsCon:before {
    content: "";
    display: inline-block;
    width: 84px;
    height: 18px;
    position: absolute;
    top: 5px;
    right: 86px;
    z-index: 1;
    animation: opty 1s backwards, dhpic .5s linear 3s infinite alternate, shake 1s infinite;
  }

  @-webkit-keyframes opty {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  @keyframes opty {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  @-webkit-keyframes dhpic {
    0% {
      transform: scale(1);
      -webkit-transform: scale(1);
    }

    100% {
      transform: scale(1.1);
      -webkit-transform: scale(1.1);
    }
  }

  @keyframes dhpic {
    0% {
      transform: scale(1);
      -webkit-transform: scale(1);
    }

    100% {
      transform: scale(1.1);
      -webkit-transform: scale(1.1);
    }
  }

  @keyframes shake {
    0% {
      -webkit-transform: translateX(0);
      transform: translateX(0);
    }

    50% {
      -webkit-transform: translateX(5px);
      transform: translateX(5px);
    }

    100% {
      -webkit-transform: translateX(0);
      transform: translateX(0);
    }
  }

  .smsCon .codelogo {
    width: 80px;
    height: 80px;
    position: relative;
  }

  .codelogo .ermOrPcIcon {
    font-size: 44px;
    color: var(--main-color);
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 8;
  }

  .codelogo .triangleL {
    width: 100%;
    height: 100%;
    background: url('https://presale.jhtsoft.com/picms/abd9b835156a8.png') center no-repeat;
    background-size: auto 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 10;
    cursor: pointer;
  }

  .codelogo .triangleR {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 7;
    border-right: 40px solid #E8E8E8;
    border-bottom: 40px solid #E8E8E8;
    border-left: 40px solid transparent;
    border-top: 40px solid transparent;
    transform: rotate(-90deg);
  }

  .qrcodeImg {
    position: relative;
    width: 220px;
    height: 220px;
    margin: 0 auto;
    box-shadow: 0 0 8px #ddd;
    position: relative;
  }

  .loginFormSpecial {
    padding: 30px 30px 61px;
  }

  .loginForm .qrcodeImg>img {
    position: absolute;
    width: 100%;
    height: auto;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
  }

  .qrcodeDesc {
    text-align: center;
    color: #666;
    margin: 18px auto;
  }

  .qrcodeDesc i {
    margin-right: 5px;
    color: var(--main-color);
    font-size: 24px;
    vertical-align: sub;
  }

  .qrcodeError,
  .qrcodeSuccess {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 14;
    width: 100%;
    height: 100%;
  }

  .qrcodeError {
    background: rgba(0, 0, 0, .7);
  }

  .qrcodeSuccess {
    background: rgba(255, 255, 255, .98);
  }

  .qrcodeError p {
    color: #fff;
    margin-top: 35%;
    margin-bottom: 8px;
    text-align: center;
    line-height: 25px;
    font-size: 16px;
  }

  .qrcodeSuccess p {
    color: #4CA81E;
    margin-top: 35%;
    font-size: 24px;
    font-weight: 500;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .qrcodeSuccess p::before {
    font-size: 24px;
    padding-right: 10px;
  }

  .qrcodeError button,
  .qrcodeSuccess button {
    text-align: center;
    margin: 0 auto;
    display: block;
    color: #fff;
    font-size: 12px;
    cursor: pointer;
    background: var(--main-color);
    border-width: 0;
    border-color: #fff;
    border-radius: 17px;
    outline: 0;
    padding: 6px 12px;
  }

  .qrcodeSuccess button {
    color: #333;
    background: none;
    border-radius: none;
    border: none;
    font-size: 16px;
    padding: 15px 0;
  }

  .recoverDlog>>>.el-dialog {
    width: 620px;
    min-width: 620px;
  }

  .vxBingdingBox>>>.el-form-item__content {
    flex: 1;
  }

  .cursorHand {
    cursor: pointer;
  }

  /* E 2023-05-11 DHL 微信扫码登录样式 */
  /*修改账户密码弹窗*/
  .editPDlg>>>.el-dialog {
    width: 650px;
  }

  /*系统提示版本错误 */
  .codeDlog>>>.el-dialog {
    width: 630px
  }

  .codeDlog p {
    color: #666;
    line-height: 25px;
    font-size: 16px
  }

  .codeDlog small {
    display: block;
    padding: 10px 0 0 10px;
    text-align: left;
    line-height: 20px
  }

  .codeDlog>>>.el-button {
    padding: 8px 15px
  }

  .codeDlog>>>.el-dialog__body {
    padding: 30px 50px !important
  }

  .codeDlog>>>.el-dialog__footer {
    box-shadow: none;
    margin-bottom: 5px
  }

  .codeDlog>>>.el-icon-warning {
    font-size: 24px;
    line-height: 24px;
    color: #e6a23c
  }

  /*引导关注公众号弹窗*/
  .leadEwmDlog>>>.el-dialog {
    width: 850px;
    padding-bottom: 0;
  }

  .leadEwmDlog .btnLeadClose {
    position: absolute;
    z-index: 4;
    right: 10px;
    top: 10px;
    font-size: 34px;
    color: #000;
    cursor: pointer;
  }

  .leadEwmDlog>>>.el-dialog__header {
    display: none;
  }

  .leadEwmDlog>>>.el-dialog__body {
    position: relative;
    padding: 70px 20px 120px !important;
  }

  .leadEwmDlog>>>.el-dialog__body:before {
    position: absolute;
    content: '';
    z-index: 2;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    background: url('https://presale.jhtsoft.com/picms/c534e60af8c38.png') no-repeat center 5px;
    background-size: 98% calc(100% - 10px);
  }

  .leadContBox {
    position: relative;
    z-index: 3;
  }

  .leadContBox h2 {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    color: #000;
  }

  .leadContBox .qrcodeImg {
    background: var(--main-color);
    border-radius: 8px;
    box-shadow: none;
    width: 180px;
    height: 180px;
    padding: 5px;
    margin: 30px auto 40px;
  }

  .leadContBox .qrcodeImg>img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
  }

  .leadContBox article {
    color: #000;
    text-indent: 2em;
    line-height: 25px;
    width: 52%;
    margin: 0 auto;
  }

  .leadContBox article b {
    font-size: 18px;
    color: var(--main-color);
    font-weight: bold;
  }

  .leadContBox ul {
    margin: 30px auto 80px;
    width: 76%;
  }

  .leadContBox ul li {
    position: relative;
    display: inline-block;
    width: calc(50% - 10px);
    font-size: 12px;
    color: #000;
    line-height: 20px;
    padding: 5px;
    box-sizing: border-box;
  }

  .leadContBox ul li i {
    display: inline-block;
    width: 15px;
    height: 15px;
    border-radius: 100%;
    background: var(--main-color);
    color: #fff;
    text-align: center;
    line-height: 15px;
    margin: 2.5px 27px 2.5px 0;
  }

  .leadContBox ul li:before {
    position: absolute;
    left: 24px;
    top: 9px;
    font-size: 12px;
    line-height: 1;
    font-weight: bold;
    background: -webkit-linear-gradient(to right, var(--main-color), #ecf2f7);
    background: linear-gradient(to right, var(--main-color), #ecf2f7);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
  }

  .bottomTip {
    position: absolute;
    z-index: 1;
    left: 50%;
    bottom: 50px;
    margin-left: -135px;
    display: block;
    width: 270px;
    height: 90px;
    text-align: right;
    background: url('https://presale.jhtsoft.com/picms/ca0a1e96a13cc.gif') no-repeat left 40px;
    background-size: auto 25px;
  }

  .bottomTip img {
    height: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/views/Login/Login.vue